import dayjs from 'dayjs'

import { BookingStatus } from 'src/graphql/types/bookings'
import { formatSnakeValue } from 'src/lib/formatters'

export const calculateWeekDateRange = () => {
  const currentDate = new Date()
  const daysToSubtract = currentDate.getDay()
  const startOfWeek = dayjs(currentDate).subtract(daysToSubtract, 'day')
  return {
    startDate: startOfWeek.startOf('day').toDate(),
    endDate: startOfWeek.add(6, 'day').endOf('day').toDate(),
  }
}

export const subtractWeek = ({ start, end }) => ({
  startDate: dayjs(start).subtract(7, 'day').startOf('day').toDate(),
  endDate: dayjs(end).subtract(7, 'day').endOf('day').toDate(),
})

export const addWeek = ({ start, end }) => ({
  startDate: dayjs(start).add(7, 'day').startOf('day').toDate(),
  endDate: dayjs(end).add(7, 'day').endOf('day').toDate(),
})

export const isBookingOnDay = (
  booking: { bookingStartTime: string | Date },
  day: Date
): boolean => dayjs(booking.bookingStartTime).isSame(dayjs(day), 'day')

export const bookingStatusOptions = Object.keys(BookingStatus).map((key) => ({
  value: BookingStatus[key],
  label: formatSnakeValue(BookingStatus[key]),
}))
